import React from 'react';
import { StyleSheet, css } from 'aphrodite';
import { ApiHelper } from '../../common/helpers/ApiHelper';
import { Helper } from '../../common/helpers/Helper';
import { BaseEntityPage } from '../../common/components/BaseEntityPage';
import { UiHelper } from '../../common/helpers/UiHelper';
import { AppStyles, AppTheme } from '../../styles/AppTheme';
import { attachDetachForm } from '../../data/data';
import { DynamicFormDialog } from '../../common/components/DynamicFormDialog';
import { Tooltip } from '@material-ui/core';
import { VenueSummary2 } from '../../components/VenueSummary2';
import { SearchBar } from '../../common/components/SearchBar';

export class CampaignVenues extends BaseEntityPage {

  constructor(props, options) {
    super(props, options)
    this.pageKey = 'CampaignVenues'
    this.orgId = this.props.match.params.orgId || 'PRODUCT'
    this.campaignId = this.props.match.params.id
    this.noTableHead = true
    this.displayCheckBoxTable = true

    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute({ home: true }) },
      { title: Helper.getString('campaigns'), to: this.baseRoute() + '/campaigns' },
      { title: Helper.getString('mediaAndDetails'), to: this.baseRoute() + '/campaigns/' + this.campaignId },
      { title: Helper.getString('venues') },
    ]

    const isProductOrg = this.orgId === 'PRODUCT'

    this.toFetch = [
      {
        method: 'GET',
        paths: ['miscs', 'venues-of-campaign'],
        queryParams: { campaignId: this.campaignId }
      },
      {
        method: 'GET',
        paths: ['campaigns', this.campaignId]
      },
      ...(!isProductOrg ? [{
        method: 'GET',
        paths: ['miscs', 'venues-of-org'],
        queryParams: {
          orgId: this.orgId,
          limit: 2000,
          state: 'LIVE',
        }
      }] : [])
    ]

    this.tableHeadersMap = {
      Index: (current) => current.__index + 1,
      Info: (current) => this.renderVenueInfo(current)
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.apiData = {
    }
    this.state = {
      ...this.state,
      searchText: ''
    }
    this.headerActions = [
      {
        icon: 'add',
        label: Helper.getString('bulkAttach'),
        type: 'icon-mobile',
        onClick: () => this.openAttachDetachForm('Attach')
      },
      {
        icon: 'remove',
        label: Helper.getString('bulkDetach'),
        type: 'icon-mobile',
        onClick: () => this.openAttachDetachForm('Detach')
      }
    ]
    this.export = {
      buttonTitle: 'Download Attached',
      headers: {
        deviceCode: 'venueCode',
        title: 'title',
        siteTitle: 'siteTitle',
        siteAddress: 'siteAddress',
        extId: 'extId',
        serialNumber: 'serialNumber',
        screenType: 'screenType',
        screenPlacement: 'screenPlacement',
        screenDimension: 'screenDimension',
        screenModel: 'screenModel',
        screenBrand: 'screenBrand',
        state: 'state',
      },
      format: 'xlsx'
    }
  }

  _makeDeivceInfo = (item) => {
    const sn = item.latestDeviceFeed && item.latestDeviceFeed.serialnumber || item.serialNumber || null
    const placement =  item.info && item.info.screenPlacement || null
    return [
      item.deviceCode,
      placement && `Placement: ${placement}`,
      sn,
      item.extId
    ].filter(Boolean).join(' | ')
  }

  openAttachDetachForm = (actionAttachDetach) => {
    Helper.populateFormDefinitionValues(
      attachDetachForm.fieldDef,
      {
        campaignId: this.campaignId,
        venueCodesStr: ''
      }
    )

    this.setState({ showAttachDetachForm: true, actionAttachDetach })
  }

  openAttachDetachForSelected = (
    actionAttachDetach,
    checkedItems
  ) => {

    const venueCodes = checkedItems
      .map(x => x.deviceCode)
      .join(', ')

    Helper.populateFormDefinitionValues(
      attachDetachForm.fieldDef,
      {
        campaignId: this.campaignId,
        venueCodesStr: venueCodes
      }
    )

    this.setState({
      showAttachDetachForm: true,
      actionAttachDetach
    })
  }

  onFetchSuccess(results, options = {}) {
    const attachedVenueResult = results[0] || {}

    if (options.fetchNext) {
      const attachedItems = (attachedVenueResult.items || []).map(screen => ({
        ...screen,
        _selected: false,
        isAttached: true
      }))
      const items = (this.state.items || []).concat(attachedItems)

      this.handleNextpage(attachedVenueResult)
      this.setState({
        items,
        allItems: items,
        attachedItems: items
      })
      return
    }

    const orgVenueResult = results[2]
    const useLegacyAttach =
      !orgVenueResult || orgVenueResult.nextPage || attachedVenueResult.nextPage
    const attachedVenueItems = (attachedVenueResult.items || []).map(screen => ({
      ...screen,
      _selected: false,
      isAttached: true
    }))
    const attachedVenueCodes = attachedVenueItems.map(
      x => x.deviceCode
    )
    const orgSitesById = (orgVenueResult && orgVenueResult.sitesById) || {}

    const allScreens = ((orgVenueResult && orgVenueResult.items) || []).map(screen => {
      const siteInfo = screen.orgId && orgSitesById[screen.orgId]
      const site = siteInfo
        ? {
          title: siteInfo.title,
          address: siteInfo.address
        }
        : screen.site

      return {
        ...screen,
        site,
        _selected: false,
        isAttached: attachedVenueCodes.includes(screen.deviceCode)
      }
    })
    const attachedScreens = useLegacyAttach ? attachedVenueItems : allScreens.filter(
      screen => screen.isAttached
    )
    const items = useLegacyAttach ? attachedVenueItems : allScreens

    if (useLegacyAttach) {
      this.handleNextpage(attachedVenueResult)
    } else {
      this.setState({
        nextPage: undefined,
        nextPageState: ApiHelper.State.READY
      })
    }

    this.setState({
      items,
      allItems: items,
      attachedItems: attachedScreens,
      campaignInfo: results[1],
      orgVenueItems: (orgVenueResult && orgVenueResult.items) || [],
      orgSitesById,
      legacyAttach: useLegacyAttach
    })
    this.pageTitle = results[1].title || Helper.getString('listVenues')
    Helper.populateFormDefinitionValues(attachDetachForm.fieldDef, { campaignId: this.campaignId })
    UiHelper.populateOptions(attachDetachForm.fieldDef, { items: [{ id: this.campaignId, title: this.pageTitle }] }, 'campaignId')
  }

  makeFileName = () => {
    return 'campaign-venues-' + this.campaignId + '-' + Helper.currentTs()
  }

  prepExcelDownload() {
    const rows = []
    const items = this.state.attachedItems || []
    for (const item of items) {
      const e = {}
      for (const hKey in this.export.headers) {
        e[this.export.headers[hKey]] =
          this.exportRowItemValue(hKey, item)
      }
      rows.push(e)
    }
    return rows
  }

  handleSearch = (value) => {
    const keyword = value.trim().toLowerCase()

    if (!keyword) {
      this.setState({
        searchText: '',
        items: this.state.allItems
      })
      return
    }

    const filtered = this.state.allItems.filter(current => {
      const searchableText = [
        current.title,
        current.deviceCode,
        current.deviceName,
        current.extId,
        current.serialNumber,
        current.site && current.site.title,
        current.site && current.site.address,
        current.info && current.info.title,
        current.info && current.info.address,
        current.info && current.info.openoohcategory,
        current.info && current.info.screenPlacement,
        current.info && current.info.screenBrand,
        current.info && current.info.screenModel,
        current.info && current.info.screenDimension
      ]
        .filter(Boolean)
        .join(' ')
        .toLowerCase()

      return searchableText.includes(keyword)
    })

    this.setState({
      searchText: value,
      items: filtered
    })
  }

  exportRowItemValue(key, current) {
    const siteInfo = current.site || current.siteInfo

    const serialNumber = current.latestDeviceFeed && current.latestDeviceFeed.serialnumber
      ? current.latestDeviceFeed.serialnumber
      : current.serialNumber

    switch (key) {
    case 'serialNumber':
      return serialNumber || ''

    case 'screenType':
      return current.info && current.info.openoohcategory
        ? current.info.openoohcategory
        : ''

    case 'siteTitle':
      return (siteInfo && siteInfo.title) || (current.info && current.info.title)

    case 'siteAddress':
      return (siteInfo && siteInfo.address) || (current.info && current.info.address)

    case 'category':
      return current.info && current.info.category
        ? current.info.category
        : ''

    case 'screenModel':
      return current.info && current.info.screenModel
        ? current.info.screenModel
        : ''

    case 'screenPlacement':
      return current.info && current.info.screenPlacement
        ? current.info.screenPlacement
        : ''

    case 'screenDimension':
      return current.info && current.info.screenDimension
        ? current.info.screenDimension
        : ''

    default:
      return super.exportRowItemValue(key, current)
    }
  }

  renderVenueInfo(current) {
    return (
      <div className={css(Styles.venueInfoWrapper)}>
        <VenueSummary2
          item={current}
          site={current.site}
        />

        <span
          className={css(
            Styles.attachBadge,
            current.isAttached
              ? Styles.attachBadgeAttached
              : Styles.attachBadgeDetached
          )}
        >
          {current.isAttached ? 'Attached' : 'Detached'}
        </span>
      </div>
    )
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) return ''
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  handleAttachDetachCustomSubmit = async (options) => {
    const { formData, caller } = options
    ApiHelper.call({
      method: 'post', paths: ['miscs', (this.state.actionAttachDetach === 'Attach') ? 'venues-of-campaign-attach' : 'venues-of-campaign-detach'],
      jsonBody: { ...formData }
    }, (err, result) => {
      if (err) {
        const errorMessage = Helper.getErrorMsg(err)
        caller.setState({
          fetchState: ApiHelper.State.ERROR,
          errMsg: errorMessage,
          success: false,
          message: errorMessage,
          inProcess: false
        })
        return
      }else {
        caller.setState({
          fetchState: ApiHelper.State.ERROR,
          errMsg: '',
          success: (result && result.failed > 0) ? false : true,
          message: ( result && result.failed > 0) ? Helper.getString('campaignUpdateFailed') :  Helper.getString('campaignUpdateSuccess'),
          inProcess: false
        })

        if(result && result.failed > 0) return;
        this.setState({ showAttachDetachForm: false },()=>{
          this.fetchItems()
        })
      }
    })

  }
  renderAboveTable() {

    attachDetachForm.fieldDef.title = 'Bulk ' + this.state.actionAttachDetach
    return (
      <div className={css(Styles.renderAboveTable)}>
        {!this.state.legacyAttach && (
          <div className={css(Styles.searchWrapper)}>
            <div className={css(Styles.searchContainer)}>
              <SearchBar
                hint='Search screens'
                inProcessSearch={false}
                callSearchOnEmptyText={true}
                onSearch={this.handleSearch}
                searchText={this.state.searchText}
                showRecentButtonText='Search'
              />
            </div>
          </div>
        )}
        <DynamicFormDialog
          customSubmit={(options) => {
            this.handleAttachDetachCustomSubmit(options)
          }}
          formDefinition={attachDetachForm.fieldDef}
          isOpen={this.state.showAttachDetachForm || false} // Added false for fixing console warning.
          onClosed={() => { this.setState({ showAttachDetachForm: false }) }}
        >
        </DynamicFormDialog>
      </div>

    )
  }

  onActions(current) {
    const actions = []
    return actions
  }

  checkBoxActions = (checkedItems) => {
    const actions = []

    if (!this.state.legacyAttach) {
      actions.push(
        <button
          key='attachSelected'
          className={css(Styles.selectedActionButton)}
          onClick={() => {
            const detachedItems = checkedItems.filter(
              x => !x.isAttached
            )

            this.openAttachDetachForSelected(
              'Attach',
              detachedItems
            )
          }}
        >
          Attach (Selected)
        </button>
      )
    }

    actions.push(
      <button
        key='detachSelected'
        className={css(Styles.selectedActionButton)}
        onClick={() => {
          const attachedItems = checkedItems.filter(
            x => x.isAttached
          )

          this.openAttachDetachForSelected(
            'Detach',
            attachedItems
          )
        }}
      >
      Detach (Selected)
      </button>
    )

    return actions
  }

}

const Styles = StyleSheet.create({
  storeNameText:{
    fontWeight: 'bolder',
    fontSize: '16px',
    color: '#121212'
  },
  line2: {
    fontSize: 12
  },
  img: {
    height: 30
  },
  icons: {
    fontSize: 40,
    color: 'lightgray'
  },
  cardStyle: {
    marginBottom: 10
  },
  outerContainer: {
    background: '#ffffff8c'
  },
  mediaDeleted: {
    color: '#ff0d0d'
  },
  circleFill: {
    width: 18,
    height: 18,
    borderRadius: '50%',
  },
  modalHeader: {
    padding: 20,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 14
  },
  modalTitle: {
    color: '#222222',
    fontSize: 26,
  },
  modalContent: {
    maxWidth: 600,
    minWidth: 200,
    paddingTop: 0,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 30,
  },
  modalCloseButton: {
    position: 'absolute',
    top: 23,
    right: 30,
    padding: 0,
    border: 'none',
    backgroundColor: 'transparent',
    display: 'flex',
    outline: 'none',
    cursor: 'pointer',
  },
  modalCloseIcon: {
    width: 18,
    height: 18,
    padding: 1,
    fill: AppTheme.primaryColor,
    borderRadius: AppTheme.borderRadius
  },
  root: {
    zIndex: 13000,
  },
  paper: {
    borderRadius: AppTheme.borderRadius
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 10
  },
  errMsg: {
    margin: 0,
    color: 'red',
    fontSize: 14,
    marginRight: 10
  },
  bulkPasteTextBox: {
    borderRadius: AppTheme.borderRadius,
    border: '1px solid #E5E5E5',
    overflow: 'hidden',
    width: 400,
    padding: 20
  },
  buttonHolder:{
    float: 'right',
    paddingTop: 10
  },
  venueInfoWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },

  attachBadge: {
    padding: '6px 14px',
    borderRadius: 6,
    fontSize: 12,
    fontWeight: 600,
    minWidth: 90,
    textAlign: 'center',
    marginLeft: 20
  },

  attachBadgeAttached: {
    background: '#E6F7EC',
    color: '#1B8A3A'
  },

  attachBadgeDetached: {
    background: '#F2F2F2',
    color: '#777777'
  },
  selectedActionButton: {
    background: AppTheme.primaryColor,
    color: '#FFFFFF',
    border: 'none',
    borderRadius: 7,
    padding: '6px 15px',
    minWidth: 100,
    height: 32,
    fontFamily: 'inherit',
    fontSize: 10,
    fontWeight: 500,
    cursor: 'pointer',
    marginLeft: 10,
    outline: 'none',
    boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
  },
  searchWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 16
  },

  searchContainer: {
    width: '100%',
    maxWidth: AppTheme.viewPort
  },
  renderAboveTable: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
  },
})



// WEBPACK FOOTER //
// ./src/screens/admin/CampaignVenues.js